import { createApiSlice } from "@common";
import { CRUD_ADDRESS_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addAddressType",
    method: "post",
    url: CRUD_ADDRESS_TYPE,
    stateKey: "message",
  },
  {
    name: "getAddressType",
    method: "get",
    url: CRUD_ADDRESS_TYPE,
    stateKey: "data",
  },
  {
    name: "updateAddressType",
    method: "put",
    url: CRUD_ADDRESS_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteAddressType",
    method: "delete",
    url: CRUD_ADDRESS_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"addressType",
 apiConfig, 
 customReducers);
const addressTypeSlice = slice;

export default addressTypeSlice.reducer;

export const {
  addAddressType,
  getAddressType,
  updateAddressType,
  deleteAddressType,
} = thunks;

export const { rowSelect } = actions;
